import AttackTypeIcon from "./AttackTypeIcon";

export default AttackTypeIcon;
export { AttackTypeIcon };
